module.exports = __webpack_public_path__ + "static/male-2-38b1ffa9e5858c7d454d52c24147f428.jpeg";